module.exports = __webpack_public_path__ + "img/馬達控制器2.3e2af922.jpg";